import React from 'react';

export const toolContext = React.createContext('');
